import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Card, CardBody, Col, Row } from "reactstrap";
import { connect } from "react-redux";
// import Spline from '../../../../components/Charts/Spline';
import {
  capitalizeFirstLetter,
  numberWithCommas,
} from "../../../../../helpers/utils";
import ReactApexChart from "react-apexcharts";

const HorizontalBarChart = props => {
  const [options, setOptions] = React.useState({
    chart: {
      toolbar: {
        show: true,
        tools: {
          download: false,
          selection: false,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: false,
          reset: true,
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: [
      "#556ee6",
      "#f1b44c",
      "#00CBE1",
      "#946BFA",
      "#FF6900",
      "#E6D4B6",
      "#FFB4B4",
      "#46E0DA",
      "#9491E0",
      "#FBBADC",
      "#E6E5B0",
      "#FFC8BA",
    ],
    grid: {
      borderColor: "#f1f1f1",
    },
    xaxis: {
      categories: [],
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: value => `${numberWithCommas(parseFloat(value))}`,
        title: {
          formatter: tooltipName => capitalizeFirstLetter(tooltipName) + ":",
        },
      },
    },
  });

  const [series, setSeries] = React.useState([
    {
      data: [],
    },
  ]);

  React.useEffect(() => {
    setSeries([{ 
      name: 'Status',
      data: props.data.data 
    }]);
    setOptions({
      ...options,
      ...props.addons,
      ...props.data.options,
    });
  }, [props.data]);

  return (
    <React.Fragment>
      <Row>
        <Col sm={12}>
          <Row className="justify-content-between align-middle">
            <Col xs={12}>
              <ReactApexChart
                options={options}
                series={series}
                type="bar"
                height={350}
                className="apex-charts"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  );
};

HorizontalBarChart.propTypes = {
  data: PropTypes.any,
  addons: PropTypes.any,
};

export default connect()(HorizontalBarChart);
